import Vue from "vue";

export const NotificationModule = {
  actions: {
    infoNotification({}, _msg) {
      Vue.notify({
        group: "pitaya",
        title: `${_msg}`
      });
    },
    errorNotification({}, _msg) {
      Vue.notify({
        group: "pitaya",
        title: `${_msg}`,
        type: "error"
      });
    },
    successNotification({}, _msg) {
      Vue.notify({
        group: "pitaya",
        title: `${_msg}`,
        type: "success"
      });
    }
  }
};
